import { useState } from 'react';

const useInputOnchnage = (initialValue: string) => {
  const [value, setValue] = useState(initialValue);

  const handleChange = (value: string) => {
    setValue(value);
  };


  return [value, handleChange] as const;
};

export default useInputOnchnage;